import * as React from "react";
import { forwardRef } from "react";
const CardIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  "data-category": "payment-methods",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M43 15.815H5v-1.648c0-.8399.33367-1.6455.92759-2.2394C6.52152 11.3337 7.32706 11 8.167 11h31.666c.8399 0 1.6455.3337 2.2394.9276S43 13.3271 43 14.167zm0 4.815v13.203c0 .4159-.0819.8277-.2411 1.212-.1591.3842-.3924.7333-.6865 1.0274s-.6432.5274-1.0274.6865c-.3843.1592-.7961.2411-1.212.2411H8.167c-.4159 0-.82772-.0819-1.21196-.2411-.38424-.1591-.73336-.3924-1.02745-.6865-.29408-.2941-.52736-.6432-.68652-1.0274C5.08192 34.6607 5 34.2489 5 33.833V20.63zM9.294 27.37c-.38324 0-.75078.1522-1.02177.4232s-.42323.6386-.42323 1.0218.15224.7508.42323 1.0218.63853.4232 1.02177.4232h13.262c.3832 0 .7508-.1522 1.0218-.4232s.4232-.6386.4232-1.0218-.1522-.7508-.4232-1.0218-.6386-.4232-1.0218-.4232z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(CardIcon);
ForwardRef.category = "payment-methods";
export { ForwardRef as CardIcon };